<template>
  <el-card header="协议信息" class="box-card">
    <el-form
      :model="formData"
      :rules="rules"
      ref="dataForm"
      label-width="100px"
    >
      <el-form-item label="语言" prop="languageId">
        <dropdown-select
          v-model="formData.languageId"
          :action="api.dealer.language.all"
          textField="name"
          valueField="id"
        ></dropdown-select>
      </el-form-item>

      <el-form-item label="链接地址" prop="linkUrl">
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入内容"
          v-model="formData.content">
        </el-input>
      </el-form-item>
      <el-form-item label=" ">
        <el-button type="primary" @click="submitForm">提交</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        id: null,
        languageId: null,
        content: "",
      },
      typeList: [],
      rules: {
        languageId: [{ required: true, message: "请选择语言", trigger: "blur" }],
        content: [{ required: true, message: "请输入协议内容", trigger: "blur" }],
      },
    };
  },
  created: function () {
    this.formData.id = this.$route.query.id;
    if (this.formData.id) {
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      var that = this;
      that.api.dealer.agreement.get({ id: that.formData.id }).then((response) => {
        if (!response.data.errorCode) {
          Object.assign(that.formData, response.data.data);
        }
      });
    },
    handleImgUpload(response, file, fileList) {
      this.formData.imgUrl = response.data;
    },
    submitForm() {
      var that = this;
      that.$refs["dataForm"].validate((valid) => {
        if (valid) {
          that.api.dealer.agreement
            .save(Object.assign({}, that.formData))
            .then(function (response) {
              if (!response.data.errorCode) {
                that.$router.go(-1);
              }
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs["dataForm"].resetFields();
    },
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// Edit.vue?7a24e633